var _excluded = ["children", "utils"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import StyledAlertBody from './alert.body.styles';
var propTypes = {
  /** Child elements to be rendered inside of Alert.Body */
  children: PropTypes.node,
  /** Add utility objects for styling */
  utils: PropTypes.object
};
var defaultProps = {
  children: /*#__PURE__*/React.createElement(React.Fragment, null),
  utils: {}
};
var AlertBody = function AlertBody(_ref) {
  var children = _ref.children,
    utils = _ref.utils,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledAlertBody, _extends({
    utils: utils
  }, other), children));
};
AlertBody.displayName = 'Alert.Body';
AlertBody.defaultProps = defaultProps;
AlertBody.propTypes = propTypes;
export default AlertBody;